require("../../../dyniva_ui/bower_components/bootstrap/js/modal");

// ----- 上面部分按需使用 ----- //
// ----- ==  ReadMe  == ----- //
// ----- 下面部分自行修改 ----- //

let Drupal = window.Drupal || {};

(function ($) {
  Drupal.behaviors.siteScript = {
    first: true,
    attach(context) {
      if (!this.first) return false;

      $("#content-modal-nav").modal({
        backdrop: false,
        show: true,
      });

      // Message alert button
      this.librarys.messages;

      // Default Set with drupal.js
      this.librarys.footer($);

      // Set Swiper 2.7.3
      // if(this.plugins && this.plugins.swipers2) this.plugins.swipers2.init();

      this.first = false;
    },
    plugins: {
      // Plugins
      // 'swipers2' : require('./plugins/swipers2')
    },
    librarys: {
      // Core
      messages: require("../../../dyniva_ui/bower_components/bootstrap/js/alert"),
      footer: require("./drupal/dynivaui.footer"),
    },
  };

  Drupal.behaviors.ween_contour = {
    attach(context) {
      var ids = {};
      $("*[data-dyniva-contour]", context).each(function () {
        var $this = $(this);
        var id = $this.attr("data-dyniva-contour");
        var h = $this.height();
        ids[id] = ids[id] > h ? ids[id] : h;
      });

      Object.keys(ids).forEach(function (id) {
        $("*[data-dyniva-contour=" + id + "]", context).height(ids[id]);
      });
    },
  };

  Drupal.behaviors.tab_5_0 = {
    attach(context) {},
    onTabChange(uuid, tab, isInit) {
      if (tab.link && !isInit) {
        location.href = tab.link;
      } else {
        $("*[data-tab-5-0=" + uuid + "]").each(function () {
          if (
            $(this).attr("data-tab-5-0-title") === tab.text ||
            escape(tab.text).replace(/%u/gi, "\\u").toUpperCase() ===
              $(this).attr("data-tab-5-0-title").toUpperCase()
          ) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    },
    getDefaultTab(items, id) {
      if (id) {
        return items.find(function (item) {
          return item.id === id;
        });
      } else {
        return items[0].text;
      }
    },
  };

  /**
   * 定义loading方法
   */
  $.fn.showLoading = function () {
    var $load =
      '<svg class="load" viewBox="22 22 44 44">\n' +
      '  <circle class="loading" cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"/>\n' +
      "</svg>";

    if ($(this).css("position") === "static") {
      $(this).css("position", "relative");
    }

    $(this).attr("data-loading", "loading");
    $(this).append($load);
  };
  $.fn.hideLoading = function () {
    $(this).removeAttr("data-loading", "");
    $(this).find(".load").remove();
  };

  $.extend({
    onAway: function (selector, event, callback) {
      $(document).on(event, function (e) {
        var target = $(e.target);
        if (target.closest(selector).length === 0) {
          callback && callback();
        }
      });
    },
  });

  // 首页的form效果
  (function () {
    // $('#block-webform-helpdesk .block-title').html('<img src="/themes/custom/ween_ui/templates/ui/images/page-home--talk.png"/>');
    $("#block-webform-helpdesk .webform-submission-helpdesk-form").prepend(
      '<div class="text-right text-primary font-bold"><i class="form-close icon icon-minus cursor-pointer"></i></div>'
    );
    $("#block-webform-helpdesk .block-title").on("click", function () {
      $(
        "#block-webform-helpdesk .webform-submission-helpdesk-form"
      ).fadeToggle();
    });

    $(
      "#block-webform-helpdesk .webform-submission-helpdesk-form .form-close"
    ).on("click", function () {
      $("#block-webform-helpdesk .webform-submission-helpdesk-form").fadeOut();
    });

    $.onAway("#block-webform-helpdesk", "click", function () {
      $("#block-webform-helpdesk .webform-submission-helpdesk-form").fadeOut();
    });
  })();

  // 搜索页调整
  // (function () {
  //   $('body.page-search, body.page-document-search, body.page-news-event-search').find('#block-ween-ui-content .contextual-region').removeClass('search-1-0').addClass('container table-1-0');
  // })();

  // about 页面点击弹窗
  (function () {
    function renderModal() {
      $("body").append(
        '<div class="about-management-cards-modal fixed top-0 left-0 w-screen h-screen text-white flex" style="background-color: rgba(0, 0, 0, .9); z-index: 9999;">' +
          '<div class="w-full h-full relative">' +
          '<div class="about-management-cards-modal-close absolute text-xl" style="top: 80px; right: 80px;"><div class="i icon icon-close"></div></div>' +
          '<i class="icon icon-left y-m text-4xl" style="left: 80px;"></i>' +
          '<i class="icon icon-right y-m text-4xl" style="right: 80px;"></i>' +
          '<div class="about-management-cards-content x-y-m flex" style="width: calc(100% - 400px)">' +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>"
      );
    }

    function renderContent(img, title, jobTitle, jobDesc) {
      $(".about-management-cards-content").html(
        '<div class="flex-none">' +
          '<img src="' +
          img +
          '" alt="" srcset="">' +
          '<div class="pt-20 space-y-20 bg-wihte">' +
          '<div class="text-xl">' +
          title +
          "</div>" +
          '<div class="text-xl">' +
          jobTitle +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="flex-1 pl-40 text-xl flex items-center tracking-wide leading-30">' +
          jobDesc +
          "</div>"
      );
    }

    function findText($this) {
      return [
        $this.find("img").attr("src"),
        $this.find(".field-title").text(),
        $this.find(".field-job-title").text(),
        $this.find(".field-body").text(),
      ];
    }

    var $current = null;
    $(".about-management-cards")
      .find(".views-row")
      .on("click", function () {
        $current = $(this);

        renderModal();
        renderContent.apply(null, findText($current));

        $(".about-management-cards-modal .icon-left").on("click", function () {
          if ($current.prev().length === 0) {
            return;
          }
          $current = $current.prev();
          renderContent.apply(null, findText($current));
        });

        $(".about-management-cards-modal .icon-right").on("click", function () {
          if ($current.next().length === 0) {
            return;
          }
          $current = $current.next();
          renderContent.apply(null, findText($current));
        });

        $(".about-management-cards-modal-close").on("click", function () {
          $(".about-management-cards-modal").remove();
        });
      });
  })();

  // product vedios的显隐
  (function () {
    if ($(".page-product-vedios-wrapper").length) {
      if (
        $(".page-product-vedios-wrapper .page-vedios .views-view-grid")
          .length === 0
      ) {
        $(".page-product-vedios-wrapper").hide();
      }
    }
  })();

  // application 详情页点击图片弹窗显示
  (function () {
    if ($(".page-application-detail-cards").length) {
      $(".page-application-detail-cards")
        .find(".field-item img")
        .each(function () {
          $(this).attr("data-toggle", "modal");
          $(this).attr("data-mode", "image");
          $(this).attr("data-src", $(this).attr("src"));
        });
    }
  })();

  // 首页轮播控制form 显隐
  (function () {
    if ($(".page-home-carouse .dy-carousel").length) {
      $(".page-home-carouse .dy-carousel ").on(
        "click",
        ".slick-arrow",
        function () {
          if (
            $(this)
              .parent()
              .find('.carousel-item[aria-hidden="false"]')
              .attr("data-index") === "0"
          ) {
            $(this)
              .parents(".layout--twocol-overlap-section")
              .find(".layout--twocol-overlap-section-second")
              .show();
          } else {
            $(this)
              .parents(".layout--twocol-overlap-section")
              .find(".layout--twocol-overlap-section-second")
              .hide();
          }
        }
      );
    }
  })();
})(jQuery);
